export default __webpack_public_path__ + "media/zurb/img/events/wired/dst/dst-photos-75569ab01cf6ca531e6361627aa3a4d4.png";